import { createAsyncThunk } from '@reduxjs/toolkit';

import { getMessageIsFromMe } from '../messageSelector';

const messageUpdateImageDimensions = createAsyncThunk(
  'message/messageUpdateImageDimensions',
  async ({ messageId, width, height }, { getState, extra: { gccApiClient } }) => {
    const messageIsFromMe = getMessageIsFromMe(messageId)(getState());
    if (!messageIsFromMe) {
      return;
    }

    await gccApiClient.updateMessage(messageId, {
      imgDimensions: {
        w: width,
        h: height,
      },
    });
  },
);

export default messageUpdateImageDimensions;
